import moment from 'moment';
import { useSelector } from 'react-redux';

/**
 * Whether this business may use Profit IQ, from
 * `currentBusiness.settings.profitIqConfig`:
 *
 *   allowed  -> unlocked
 *   trial    -> unlocked while now falls inside [trialStart, trialEnd)
 *   disabled -> locked
 *   missing  -> locked
 *
 * The section stays in the sidebar for everyone who can see reports, so a
 * locked business lands on the upgrade screen rather than a dead link.
 */
export function useProfitIqAccess() {
  const config = useSelector(
    (state) => state.business?.currentBusiness?.settings?.profitIqConfig
  );

  if (config?.state === 'allowed') {
    return { isLocked: false, isTrial: false, trialEnd: null };
  }

  if (config?.state === 'trial') {
    const now = moment();
    const isRunning =
      !!config.trialStart &&
      !!config.trialEnd &&
      now.isSameOrAfter(config.trialStart) &&
      now.isBefore(config.trialEnd);
    return {
      isLocked: !isRunning,
      isTrial: isRunning,
      trialEnd: config.trialEnd,
    };
  }

  return { isLocked: true, isTrial: false, trialEnd: null };
}

export default useProfitIqAccess;
